import React from "react";
import Typography from "./Typography";
import { g100 } from "@carbon/themes";

const Footer = _ => {
    return (
        <footer style={{ display: "flex", flexDirection: "column", padding: "80px 32px", gap: "16px" }}>
            <Typography className='cds--type-helper-text-02' color={g100.textHelper}>SQM - SALAR</Typography>
            <img src="/assets/images/terrestra.svg" alt="terrestra" width="105.79px" height="16px" />
            <Typography className='cds--type-helper-text-02' color={g100.textHelper}>
                2026
            </Typography>
        </footer >
    );
}

export default Footer;
